import { LinearProgress } from "@material-ui/core";
import { useEffect, useState } from "react";
import { pStatus } from "../../utils/parameters";
import { useVideo } from '../../api/VideoProvider'
import { useTimerProvider } from "../../api/TimerProvider";

export function VideoTimer() {
    const { timer, configTimer } = useTimerProvider();

    return (
        <LinearProgress className='sig_Home_Progress' variant="determinate" value={100 * timer / configTimer['start']} />
    )
}